import { BackgroundCheckConfig, BackgroundCheckQuota, BackgroundCheckTest } from '@/backend/features/background-check/defaults';
import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { AppContext, ReadonlyStorageAppContext } from '@juvare/platform-app/App';
import { SettingColumns, SettingData, settingEntityName } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';
import { AppState } from '@juvare/platform-sdk-react/types';

export function getBackgroundCheckConfig(context: ReadonlyStorageAppContext<AppState>) {
    const settingStorage = context.storage<SettingData, SettingColumns>(settingEntityName);

    const backgroundCheckConfigJSON = settingStorage.list({
        filter: [
            {
                column: 'name',
                op: '=',
                value: 'backgroundCheckConfig',
            },
        ],
    }).rows[0]?.columns?.value;

    const backgroundCheckConfig: BackgroundCheckConfig | undefined = backgroundCheckConfigJSON
        ? JSON.parse(backgroundCheckConfigJSON)
        : undefined;

    return backgroundCheckConfig;
}

export function getBackgroundCheckTestConfig(context: AppContext<AppState>) {
    const settingStorage = context.storage<SettingData, SettingColumns>(settingEntityName);

    const backgroundCheckTestConfigJSON = settingStorage.list({
        filter: [
            {
                column: 'name',
                op: '=',
                value: 'backgroundCheckTest',
            },
        ],
    }).rows[0]?.columns?.value;

    const backgroundCheckTestConfig: BackgroundCheckTest | undefined = backgroundCheckTestConfigJSON
        ? JSON.parse(backgroundCheckTestConfigJSON)
        : undefined;

    return backgroundCheckTestConfig;
}

export function getBackgroundCheckQuotaConfig(context: AppContext<AppState>) {
    const settingStorage = context.storage<SettingData, SettingColumns>(settingEntityName);

    const backgroundCheckTestQuotaJSON = settingStorage.list({
        filter: [
            {
                column: 'name',
                op: '=',
                value: 'backgroundCheckQuota',
            },
        ],
    }).rows[0]?.columns?.value;

    const backgroundCheckQuotaConfig: BackgroundCheckQuota | undefined = backgroundCheckTestQuotaJSON
        ? JSON.parse(backgroundCheckTestQuotaJSON)
        : undefined;

    return backgroundCheckQuotaConfig;
}

export function getBackgroundCheckConfigForType(context: ReadonlyStorageAppContext<AppState>, type: BackgroundCheckType) {
    const backgroundCheckConfig: BackgroundCheckConfig | undefined = getBackgroundCheckConfig(context);

    return backgroundCheckConfig?.type[type];
}
